import React from 'react';
import { UserQuery_node_TEDSYSUser__Associations_Franvaro_All } from '../../Queries/_QueryTypes/UserQuery';
import {
  FranvaroReservForQuery,
  FranvaroReservForQueryVariables,
  FranvaroReservForQuery_db_SYSFranvaro_All,
} from '../../Components/FranvaroReservFor/Queries/_QueryTypes/FranvaroReservForQuery';
import { ApolloQueryResult } from '@apollo/client';
import { SYSFranvaroSysoptionQuery_db_SYSOptions_All } from './Queries/_QueryTypes/SYSFranvaroSysoptionQuery';

export interface IFranvaroContext {
  franvaroDialogOpen: boolean;
  editFranvaro:
    | undefined
    | UserQuery_node_TEDSYSUser__Associations_Franvaro_All;
  franvaroReservID: string | null;
  franvaroReservForData: FranvaroReservForQuery_db_SYSFranvaro_All[];
  franvaroReservForQueryLoading: boolean;
  franvaroReservForRefetch: (
    variables?: Partial<FranvaroReservForQueryVariables> | undefined
  ) => Promise<ApolloQueryResult<FranvaroReservForQuery>>;
  registerFranvaroDialogOpen: boolean;
  setFranvaroDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setEditFranvaro: React.Dispatch<
    React.SetStateAction<
      undefined | UserQuery_node_TEDSYSUser__Associations_Franvaro_All
    >
  >;
  setFranvaroReservID: React.Dispatch<React.SetStateAction<string | null>>;
  setRegisterFranvaroDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sysoptions: SYSFranvaroSysoptionQuery_db_SYSOptions_All[] | null | undefined;
}

export const FranvaroContext = React.createContext<IFranvaroContext>({
  franvaroDialogOpen: false,
  editFranvaro: undefined,
  franvaroReservID: null,
  franvaroReservForData: [],
  franvaroReservForQueryLoading: true,
  franvaroReservForRefetch: function (
    variables?: Partial<FranvaroReservForQueryVariables> | undefined
  ): Promise<ApolloQueryResult<FranvaroReservForQuery>> {
    throw new Error(
      'franvaroReservForRefetch not implemented when trying to refetch with variables'
    );
  },
  registerFranvaroDialogOpen: false,
  setFranvaroDialogOpen: (value: React.SetStateAction<boolean>): void => {
    throw new Error(
      `setFranvaroDialogOpen not implemented when trying to update with value ${value}.`
    );
  },
  setEditFranvaro: (
    value: React.SetStateAction<
      undefined | UserQuery_node_TEDSYSUser__Associations_Franvaro_All
    >
  ): void => {
    throw new Error(
      `setEditFranvaro not implemented when trying to update with value ${value}.`
    );
  },
  setFranvaroReservID: (value: React.SetStateAction<string | null>): void => {
    throw new Error(
      `setFranvaroReservID not implemented when trying to update with value ${value}.`
    );
  },
  setRegisterFranvaroDialogOpen: (
    value: React.SetStateAction<boolean>
  ): void => {
    throw new Error(
      `setRegisterFranvaroDialogOpen not implemented when trying to update with value ${value}.`
    );
  },
  sysoptions: undefined,
});
